import React, { useEffect, useState } from 'react';
import PeopelClip from './PeopelClip';
import { Testimonials } from './MultiCarousel';
import MarketApproach from './TheProcess';
import UperFooter from '../UperFooter';
import WhyArthro from './Advantages';
import '../style.css';
import './arthro3d.css';
import AOS from "aos";
import "aos/dist/aos.css";
import Cart2 from './Cart2';
import video_hero from '../../images/3D_ROBOTICS.mp4';
import img_Doctor_image from '../../images/Doctor_image.jpeg';
import img_Dr_Pratul_Jain from '../../images/Dr._Pratul_Jain.jpeg';
import img_Dr_Karnav_panchal from '../../images/Dr_Karnav_panchal.jpeg';

const testimonials = [
  {
    name: 'Dr. Pratul Jain',
    role: 'Arthroplasty Surgeon, Stirling Hospital, Jaipur',
    image: img_Dr_Pratul_Jain,
    text: `I have Personally used this novel technique on my patients. It's a really innovative product which not only saves time by reducing few manual steps but also adds to accuracy of the surgery and ultimately the outcome. It is actually a “Computer-less navigation” in the operating room. I would recommend this technique to my fellow colleagues and you can rest assured of the services provided by their ground team.`
  },
  {
    name: 'Dr. Karnav Panchal',
    role: 'MS Ortho, MCh (South Korea)',
    image: img_Dr_Karnav_panchal,
    text: `For the very first time, we used this software for one of my cases of complex primary Bilateral TKR with severe varus deformity and tibial bone defect. The software helped me in pre-deciding the cuts & implant sizes, so that I was quite relaxed performing the surgery. The cuts we task were exactly what we have planned on the software & the kind of end result in terms of stability and alignment was unmatchable. I will definitely use this software for my patients and recommend all my ortho colleagues to go for it.`
  }

];

const ourTestimonials = () => {
  return testimonials.map((item, index) => (
    <div
      key={index}
      className="card border-0 rounded-4 shadow-sm p-4 text-start m-2 d-flex flex-column justify-content-between w-100 h-100"
      style={{
        background: '#ffffff',
        border: '1px solid #e2e8f0',
        minHeight: '440px',
        boxShadow: '0 4px 25px rgba(0, 0, 0, 0.06)'
      }}
    >
      <div>
        {/* Avatar circle: Renders image if image property/path is provided, otherwise renders fallback avatar icon */}
        <div className="text-center mb-4">
          <div
            className="rounded-circle mx-auto d-flex align-items-center justify-content-center overflow-hidden position-relative"
            style={{
              width: '95px',
              height: '95px',
              backgroundColor: '#f8fafc',
              border: '3.5px solid #0066ff',
              boxShadow: '0 4px 12px rgba(0, 102, 255, 0.2)'
            }}
          >
            {item.image ? (
              <img
                src={item.image}
                alt={item.name}
                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              />
            ) : (
              <i className="bi bi-person-fill" style={{ fontSize: '48px', color: '#0066ff' }}></i>
            )}
          </div>
        </div>

        {/* Testimonial text */}
        <p
          className="text-secondary mb-4"
          style={{
            fontSize: '14.5px',
            lineHeight: '1.65',
            color: '#334155',
            fontWeight: '400'
          }}
        >
          {item.text}
        </p>
      </div>

      {/* Card Footer: Doctor details and Testimonials tag */}
      <div className="d-flex align-items-end justify-content-between pt-3 border-top border-light">
        <div>
          <h6 className="fw-bold mb-0 text-dark" style={{ fontSize: '15px' }}>
            {item.name}
          </h6>
          <small className="text-muted" style={{ fontSize: '11.5px', display: 'block', marginTop: '2px' }}>
            {item.role}
          </small>
        </div>

        <div className="d-flex align-items-center gap-1 text-nowrap">
          <span
            className="rounded-circle d-inline-block"
            style={{
              width: '10px',
              height: '10px',
              backgroundColor: '#0066ff'
            }}
          ></span>
          <span className="fw-bold text-dark" style={{ fontSize: '12px' }}>
            Testimonials
          </span>
        </div>
      </div>
    </div>
  ));
};

const Home = ({ data, loader }) => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    AOS.init({ duration: 1500 });
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 60) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div>
      {/* Hero Section - Fullscreen Responsive Video Background */}
      <div className="hero-video-wrapper">

        {/* Fullscreen Background Video */}
        <video
          src={video_hero}
          autoPlay
          loop
          muted
          playsInline
          disablePictureInPicture
          controlsList="nodownload nofullscreen noremoteplayback"
          className="hero-video-player"
        />

        {/* Scroll Down Circle Indicator - Hides smoothly on scroll */}
        <div
          className="hero-scroll-indicator text-center position-absolute bottom-0 start-50 translate-middle-x mb-4"
          style={{
            opacity: scrolled ? 0 : 1,
            visibility: scrolled ? 'hidden' : 'visible',
            transition: 'opacity 0.4s ease, visibility 0.4s ease',
            cursor: 'pointer',
            zIndex: 10
          }}
          onClick={() => window.scrollTo({ top: 600, behavior: 'smooth' })}
        >
          <div
            className="rounded-circle d-flex align-items-center justify-content-center m-auto shadow-sm"
            style={{ width: '42px', height: '42px', background: '#1e3a8a', color: '#ffffff' }}
          >
            <i className="bi bi-chevron-down fs-5"></i>
          </div>
        </div>
      </div>

      {/* Walking People Section */}
      <div>
        <PeopelClip />
      </div>

      {/* Technological Platforms (Cart2) */}
      <div className="mt-5">
        <Cart2 loader={loader} />
      </div>

      {/* The Process Section */}
      <div className="mt-4">
        <MarketApproach />
      </div>

      {/* Why ARTHRO3D Advantages Section */}
      <div>
        <WhyArthro />
      </div>

      {/* Customer Success Stories Testimonials */}
      <div className="col-11 m-auto mt-5 pt-3">
        <div className="text-center mb-4" data-aos="fade-up">
          <h2
            className="display-2 fw-medium text-dark text-center"
            style={{ fontSize: 'clamp(36px, 4.5vw, 64px)', fontWeight: '700', letterSpacing: '-0.5px' }}
          >
            Customer Success Stories
          </h2>
        </div>
        <div className="mt-4">
          <Testimonials data={ourTestimonials()} />
        </div>
      </div>

      {/* Media & Events Section */}
      <div className="col-11 m-auto my-5 py-4">
        <div className="text-center mb-4" data-aos="fade-up">
          <p className="display-2 fw-medium text-dark">ARTHRO3D in Media & Events</p>
          <p style={{ color: '#66707A', fontSize: '18px' }}>Keynote addresses, clinical presentations, and surgical innovations</p>
        </div>

        <div className="card border-0 rounded-4 shadow-sm overflow-hidden text-start" style={{ background: '#ffffff', border: '1px solid #e2e8f0', boxShadow: '0 10px 30px rgba(15, 23, 42, 0.08)' }} data-aos="fade-up">
          <div className="row g-0 align-items-center">
            <div className="col-md-5 col-12 p-3 p-md-4">
              <div className="overflow-hidden rounded-4" style={{ height: '320px' }}>
                <img
                  src={img_Doctor_image}
                  alt="Dr Manish Shah addressing Ahmedabad Orthopedic Society"
                  style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center top', borderRadius: '16px' }}
                />
              </div>
            </div>
            <div className="col-md-7 col-12 p-4 text-start">
              <span className="px-4 py-2 text-primary fw-bold rounded-pill mb-3 shadow-sm" style={{ background: '#eff6ff', border: '1px solid #bfdbfe', fontSize: '18px', display: 'inline-block', width: 'auto' }}>👤 Dr. Manish Shah</span>
              <h3 className="fw-bold text-dark fs-3 my-2" style={{ lineHeight: '1.4' }}>
                Founder of ARTHRO3D addressing the Orthopedic surgeons of Ahmedabad Orthopedic Society
              </h3>
              <p className="fs-6 text-secondary mb-4" style={{ color: '#475569', lineHeight: '1.6' }}>
                Addressing orthopedic surgeons on Mixed Reality navigation, smart glass technology, and patient-specific 3D bone platforms for modern joint replacement.
              </p>
              <div className="buttonDiv" onClick={() => { if (loader) loader(true); setTimeout(() => window.location.href = '/media', 400); }}>
                <div className="button" style={{ padding: '10px 22px', fontSize: '14px' }}>View All Media</div>
                <div className="button-clip" style={{ padding: '10px 22px', fontSize: '14px' }}>View All Media</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Uper Footer CTA */}
      <div style={{ background: 'linear-gradient(transparent 0%, transparent 50%,#0f172a 50% )' }}>
        <UperFooter data={data} />
      </div>
    </div>
  );
};

export default Home;
